import { AbstractBuilder } from "./AbstractBuilder.js";

export { CQLGeoserver }

class CQLGeoserver extends AbstractBuilder {

    static getFilterParams(harmonizedFilters) {
        const filter = super.getFilterParams(harmonizedFilters);
        return (filter.length) ? { cql_filter: `(${filter})` } : {};
    }

    static bt(property, begin, end) {
        if (typeof begin == "string") begin = `'${begin}'`;
        if (typeof end == "string") end = `'${end}'`;
        return `${property} BETWEEN ${begin} AND ${end}`;
    }

    static eq(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property}=${value}`;
    }

    static like(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property} LIKE ${value}`;
    }

    static gt(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property}>${value}`;
    }

    static gteq(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property}>=${value}`;
    }

    static lt(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property}<=${value}`;
    }

    static lteq(property, value) {
        if (typeof value == "string") value = `'${value}'`;
        return `${property}<=${value}`;
    }

    static null(property) {
        return `${property} IS NULL`;
    }

    static or(filters) {
        return this.join_(filters, " OR ");
    }

    static and(filters) {
        return this.join_(filters, " AND ");
    }

    static join_(filters, sep) {
        if (filters.length == 0) return "";
        if (filters.length == 1) return filters[0];
        let result = "";
        for (let i = 0; i < filters.length; ++i) {
            if (result.length > 0) result += sep;
            result += `(${filters[i]})`;
        }
        return result;
    }

}